import { useContext } from 'react'
import { isValidReference } from 'mobx-state-tree'
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { RootStoreContext } from '../stores/rootStore'

export const useQueryOrg = <
  TQueryFnData,
  TError = unknown,
  TData = TQueryFnData
>(
  options: UseQueryOptions<TQueryFnData, TError, TData>
): UseQueryResult<TData, TError> => {
  const { uiStore } = useContext(RootStoreContext)

  return useQuery<TQueryFnData, TError, TData>({
    ...options,
    queryKey: [...options.queryKey, uiStore.currentOrganization?.id],
    enabled:
      uiStore.isReady &&
      isValidReference(() => uiStore.currentOrganization) &&
      (options?.enabled !== undefined ? options.enabled : true),
  })
}
